import { HTTP, authHeader } from './http-service';

class GuaranteePolicyClaimService {
  list(disputeId) {
    return HTTP.get(`/guaranteePolicyClaim/dispute/${disputeId}`, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  get(guaranteePolicyClaimId) {
    return HTTP.get(`/guaranteePolicyClaim/${guaranteePolicyClaimId}`, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  options(disputeId) {
    return HTTP.get(`/guaranteePolicyClaim/dispute/${disputeId}/options`, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  create(payload) {
    return HTTP.post('/guaranteePolicyClaim', payload, { headers: authHeader() }).then((response) => response.data);
  }

  update(payload) {
    return HTTP.put('/guaranteePolicyClaim', payload, { headers: authHeader() }).then((response) => response.data);
  }

  delete(guaranteePolicyClaimId) {
    return HTTP.delete(`/guaranteePolicyClaim/${guaranteePolicyClaimId}`, {
      headers: authHeader(),
    }).then((response) => response.data);
  }
}

export default new GuaranteePolicyClaimService();
